import {
  parseNameStatusEntries,
  parseNumstatEntries,
  type NameStatusEntry,
  type ParsedNumstatEntry,
} from '../parse/index.js';
import { collectMovedSourcePaths } from '../rows/collect-moved-source-paths.js';
import { collectBinaryPathsFromNumstat } from './collect-binary-paths-from-numstat.js';

export type ParsedDiffOutput = {
  nameEntries: NameStatusEntry[];
  nameByPath: Map<string, NameStatusEntry>;
  numByPath: Map<string, ParsedNumstatEntry>;
  movedSourcePaths: Set<string>;
  binaryByPath: Set<string>;
};

export function parseDiffOutput(nameStatusRaw: string, numstatRaw: string): ParsedDiffOutput {
  const nameEntries = parseNameStatusEntries(nameStatusRaw.split('\n'));
  const nameByPath = new Map(nameEntries.map((entry) => [entry.pathInRepo, entry]));
  const numByPath = parseNumstatEntries(numstatRaw.split('\n'));
  const movedSourcePaths = collectMovedSourcePaths(nameEntries, numByPath);
  const binaryByPath = collectBinaryPathsFromNumstat(numstatRaw);
  return { nameEntries, nameByPath, numByPath, movedSourcePaths, binaryByPath };
}

export function collectChangedPaths(options: {
  nameEntries: NameStatusEntry[];
  numByPath: Map<string, ParsedNumstatEntry>;
  untracked?: string[];
}): Set<string> {
  const paths = new Set<string>();
  for (const entry of options.nameEntries) paths.add(entry.pathInRepo);
  for (const pathInRepo of options.numByPath.keys()) paths.add(pathInRepo);
  for (const pathInRepo of options.untracked ?? []) paths.add(pathInRepo);
  return paths;
}
